import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import queryString from "query-string";
import { CurrencyInput } from "../../components";
import { formatarReal } from "../../utils";
import Select from "react-select";
import{ Modal, ModalHeader, ModalBody, Button, ModalFooter} from 'reactstrap';
PouchDB.plugin(PouchdbFind);

export default class MetaUsuario extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.cadastrar = this.cadastrar.bind(this);
    this.getDefaultUsuario = this.getDefaultUsuario.bind(this);
    this.handleClickCopiarMeta = this.handleClickCopiarMeta.bind(this);
    this.handleCopiarMeta = this.handleCopiarMeta.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.selecionarUsuario = this.selecionarUsuario.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    
    this.state = {
      usuario: this.getDefaultUsuario(),
      errors: {
        desc: false,
        login: false,
        senha: false,
        senhaRepetir: false,
        email: false,
        celular: false,
        cargo: false,
        vendedores: [],
      },
      empresas: [],
      vendedoresSelecionados: [],
      meta: {
        valorMeta: "0",
        valorRealizado: 0,
        pRealizado: 0,
      },
      idUsuario: queryString.parse(this.props.location.search).id,
      usuarios: [],
      modal: false,
      usuariosSelecionados: [],
      habilitaBotaoCopiar: false,
    };
  }

  async componentDidMount() {
    await this.load();
    await this.loadUsuarios();
  }

  async load() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/usuarios/meta/${this.state.idUsuario}`,
        this.props.parameters()
      )
      .then((response) => {
        let meta = response.data.meta;
        let habilitaBotaoCopiar = this.state.habilitaBotaoCopiar;

        this.setState({ usuario: response.data.usuario }, () => {
          if (meta.valorMeta !== 0) {
            habilitaBotaoCopiar = true;
            meta.valorMeta = meta.valorMeta.toString().replace(".", ",");
            meta.pRealizado = meta.pRealizado.toString().replace(".", ",");

            this.setState({
              meta,
              habilitaBotaoCopiar,
            });
          }
        });
      });
  }

  getDefaultUsuario() {
    return {
      desc: "",
      login: "",
      senha: "",
      senhaRepetir: "",
      email: "",
      celular: "",
      cargo: "",
    };
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleChangeInput(value, tipo) {
    let meta = this.state.meta;
    meta[tipo] = value;
    this.setState({ meta });
  }

  async cadastrar() {
    let meta = this.state.meta;

    let valor = meta.valorMeta;
    valor = valor.replace("R$", "");
    valor = valor.replace(",", ".");
    valor = parseFloat(valor);

    meta.valorMeta = valor;

    let data = {
      meta,
    };

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/usuarios/meta/${this.state.idUsuario}`,
        data,
        this.props.parameters()
      )
      .then((response) => {
        this.notificar("success", "Meta alterada com sucesso!");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.notificar("warning", error.response.data.erro);
      });
  }

  async loadUsuarios() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/usuarios/lista`, this.props.parameters())
      .then((response) => {
        let usuarios = response.data.usuarios;
        usuarios = usuarios.filter(
          (user) => user._id !== this.state.usuario._id
        );

        usuarios = usuarios.map((user) => {
          user.label = user.desc;
          user.value = user._id;
          return user;
        });

        this.setState({
          usuarios,
        });
      });
  }

  async handleClickCopiarMeta() {
    if (this.state.usuarios.length === 0) {
      this.notificar("warning", "Deve existir mais de um usuário para copiar.");
      return false;
    }

    this.toggleModal();
  }

  async handleCopiarMeta() {
    if (this.state.usuarios.length === 0) {
      this.notificar("warning", "Deve existir mais de um usuário para copiar.");
      return false;
    }

    let data = {
      usuarios: this.state.usuariosSelecionados,
    };

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/usuarios/meta-copiar/${
          this.state.idUsuario
        }`,
        data,
        this.props.parameters()
      )
      .then((response) => {
        this.notificar("success", "Meta copiada com sucesso!");
        this.toggleModal();
      });
  }

  toggleModal() {
    this.setState({ modal: !this.state.modal });
  }

  selecionarUsuario(usuariosSelecionados) {
    this.setState({ usuariosSelecionados });
  }

  handleFocus(e) {
    e.target.select();
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={`Cadastrar Meta`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"usuarios"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className=""
                                  style={{
                                    float: "left",
                                    width: "100%",
                                  }}
                                >
                                  <div className="d-flex flex-wrap w-100 float-left">
                                  <div className="col-3 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Usuário</label>
                    <div className="float-left w-100">
                      <input
                        className="form-control"
                        value={this.state.usuario.desc}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Valor Meta (R$)</label>
                    <CurrencyInput
                      placeholder="R$0,00"
                      type="text"
                      value={this.state.meta.valorMeta}
                      onChange={(e) =>
                        this.handleChangeInput(e.target.value, "valorMeta")
                      }
                      onFocus={this.handleFocus}
                    />
                  </div>
                </div>

                <div className="col-3 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Valor Realizado (R$)</label>
                    <input
                      type="text"
                      className={`form-control`}
                      value={`R$ ${formatarReal(
                        this.state.meta.valorRealizado
                      )}`}
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="col-3 no-padding padding-novo-usuario">
                  <div className="form-group">
                    <label>Percentual Realizado (%)</label>
                    <input
                      type="text"
                      className={`form-control`}
                      value={`${formatarReal(this.state.meta.pRealizado)} %`}
                      disabled={true}
                    />
                  </div>
                </div>
                                  </div>

                              

                                  <div className="d-flex w-100">
                                  <div className="form-group" style={{marginRight:"5px"}}>
                                    <button
                                      className="btn btn-success"
                                      onClick={this.cadastrar}
                                    >
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Salvar
                                    </button>
                                  </div>
                                  <div className="form-group" style={{marginRight:"5px"}}>
                                    <button
                                      className="btn btn-success"
                                      onClick={this.handleClickCopiarMeta}
                                      disabled={this.state.habilitaBotaoCopiar ? false : true}
                                    >
                                      <i
                                        className="fa fa-copy"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Copiar Meta
                                    </button>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>


        <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>Copiar Meta</ModalHeader>
          <ModalBody>
            <div
              className="float-left width-100 text-center"
              style={{ padding: "10px" }}
            >
              Selecione os usuários que terão a meta igual ao usuário:{" "}
              {this.state.usuario.desc}
            </div>
            <div className="form-group" style={{ padding: "10px" }}>
              <Select
                value={this.state.usuariosSelecionados}
                onChange={this.selecionarUsuario}
                options={this.state.usuarios}
                isMulti={true}
                placeholder="Selecione os usuários"
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={this.handleCopiarMeta}>
              <i className="fa fa-copy"></i> Copiar
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleModal}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

      </React.Fragment>
    );
  }
}
